export default __webpack_public_path__ + "static/media/tree3.d8d211be.svg";